import { type CareerCardProps } from '3-components/Cards/CardCareer/CardCareer';
import { type CareerListingQuery } from 'cms/cms';
import { resolveCareerPagesToCareerCards, type CareerPage, type CareerPageItems } from './careerCardResolver';


interface CareerListingData {
    total: number;
    items: CareerCardProps[];
}

export const resolveCareerListing = (data: CareerListingQuery): CareerListingData | null => {
    const { items, total } = data.CareerPage as CareerPage;

    return {
        total: Number(total),
        items: resolveCareerPagesToCareerCards(items as CareerPageItems),
    };
};
